import httpManager from "@/app/shared/utils/httpManager";

class MfaService {
  baseUrl = "/users/mfa";

  async generateToken(body: { username: string; password: string; mfa_type: number, email?: string }) {
    const response = await httpManager.post(`${this.baseUrl}/generate-token/`, body, { isPublic: true });
    return response.data;
  }

  async verifyToken(body: { username: string; password: string; token: string; email?: string; mfa_type: number }) {
    const response = await httpManager.post(`${this.baseUrl}/verify-token/`, body, { isPublic: true });
    return response.data;
  }
}

export const mfaService = new MfaService();
